// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";
import usePageTitle from "app/pageTitle";
import CompanyNotification from "app/company_notification";

// import OTPInput from "otp-input-react";

// import { useMaterialUIController } from "context";

function CreateSwap() {
  const pageTitle = "Instant Conversion";
  usePageTitle(pageTitle);

  // const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [showCompanyNotification, setShowCompanyNotification] = useState(false);
  const [companyNotification, setCompanyNotification] = useState(null);

  const [openStatusDialog, setStatusDialog] = useState(false);
  const [statusMessage, setStatusMessage] = useState(
    "Your transfer has been submitted successfully. This may take a few moments to process."
  );

  const [currencies, setCurrencies] = useState([]);
  const [amountPlaceholder, setAmountPlaceholder] = useState("Enter Amount");
  const [amountPlaceholder1, setAmountPlaceholder1] = useState("Enter Amount");
  const [conversionAmount, setConversionAmount] = useState(null);
  const [targetAmount, setTargetAmount] = useState(null);
  const [sourceCurrency, setSourceCurrency] = useState(null);
  const [destinationCurrency, setDestinationCurrency] = useState(null);
  const [calculated, setCalculated] = useState(false);
  const [rateLine, setRateLine] = useState(null);
  const [transactionFee, setTransactionFee] = useState(null);
  const [conversionFee, setConversionFee] = useState(null);
  const [convertButtonText, setConvertButtonText] = useState("Calculate");
  const [convertiblesList, setConvertiblesList] = useState([]);
  const [destinationCurrencies, setDestinationCurrencies] = useState([]);

  const [refreshStarted, setRefreshStarted] = useState(null);
  const [timerText, setTimerText] = useState("");

  let timerCount = 0;

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("users/swaps/init.json")
        .then((result) => {
          setShowLoading(false);
          // console.log(result);
          if (result.data.status === "success") {
            setCurrencies(result.data.data.currencies);
            setConversionFee(result.data.data.conversion_fees);
            setConvertiblesList(result.data.data.convertibles);

            setStatusMessage("");
            if (result.data.notification) {
              setCompanyNotification(result.data.notification);
              if (result.data.notification.pages.includes("ALL")) {
                setShowCompanyNotification(true);
              } else if (result.data.notification.pages.includes("swap")) {
                setShowCompanyNotification(true);
              }
            }
          } else {
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setErrMsg("An error occurred.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function resetSwapForm() {
    setDestinationCurrency(null);
    setSourceCurrency(null);
    setConversionAmount("0.00");
    setTargetAmount("0.00");
    setCalculated(false);
  }

  useEffect(() => {
    if (destinationCurrency != null) {
      setAmountPlaceholder1(`${destinationCurrency} Amount`);
    }

    if (sourceCurrency != null) {
      setAmountPlaceholder(`${sourceCurrency} Amount`);
    }
    setConversionAmount("0.00");
    setTargetAmount("0.00");
  }, [destinationCurrency, sourceCurrency]);

  async function getExchangeRate() {
    setShowLoading(true);
    const json = {
      source: sourceCurrency,
      destination: destinationCurrency,
    };
    const result = await axios.post("users/swaps/rate.json", json).catch(() => {
      setShowLoading(false);
      setSeverity("error");
      setErrMsg("An error occurred.");
      setOpen(true);
    });

    setShowLoading(false);

    if (result.data.status === "success") {
      return result.data.data.rate;
    }

    setSeverity("error");
    setErrMsg(result.data.data.message);
    setOpen(true);

    return false;
  }

  function calculateConversionFee(amount, feeObject) {
    let tFee = feeObject.fee;
    if (feeObject.is_percentage) {
      tFee = amount * feeObject.fee;
      if (feeObject.minimum > 0) {
        tFee = feeObject.minimum > tFee ? feeObject.minimum : tFee;
      }

      if (feeObject.maximum > 0) {
        tFee = feeObject.maximum < tFee ? feeObject.maximum : tFee;
      }

      tFee += feeObject.mandatory_fee;
    }

    let cDiscount = feeObject.discount;
    if (feeObject.is_discount_percentage) {
      cDiscount = tFee * feeObject.discount;
    }

    tFee -= cDiscount;
    return tFee / 100;
  }

  async function calculate() {
    const conversionRate = await getExchangeRate();
    // console.log(conversionRate);
    const conversionRateText =
      conversionRate < 1 ? conversionRate.toFixed(8) : conversionRate.toFixed(2);
    const rLine = `1.00 ${sourceCurrency} = ${destinationCurrency} ${conversionRateText}`;
    setRateLine(rLine);

    if (conversionAmount !== "0.00" || conversionAmount > 0) {
      const tFee = calculateConversionFee(conversionAmount * 100, conversionFee[sourceCurrency]);
      setTransactionFee(
        tFee.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );

      const destAmount = (conversionAmount - tFee) * conversionRate;
      setTargetAmount(destAmount.toFixed(2));
    } else if (targetAmount !== "0.00" || targetAmount > 0) {
      const conVAmt = targetAmount / conversionRate;

      let tFee = calculateConversionFee(conVAmt * 100, conversionFee[sourceCurrency]);
      const cAmt = conVAmt + tFee;
      const finalConversionAmount = Math.max(Math.ceil(cAmt / 5) * 5, cAmt);
      tFee = calculateConversionFee(finalConversionAmount * 100, conversionFee[sourceCurrency]);

      setTransactionFee(
        tFee.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
      setConversionAmount(finalConversionAmount.toFixed(2));
    }

    if (refreshStarted !== null) {
      clearInterval(refreshStarted);
    }

    const id = setInterval(() => {
      timerCount += 1;
      const tLeft = 30 - timerCount;
      setTimerText(`${tLeft} secs`);
      if (timerCount >= 30) {
        clearInterval(refreshStarted);
        setCalculated(false);
        setConvertButtonText("Calculate");
      }
    }, 1000);

    setRefreshStarted(id);

    setCalculated(true);
    setConvertButtonText("Proceed");
  }

  async function postConversion() {
    setShowLoading(true);
    const json = {
      source_currency: sourceCurrency,
      destination_currency: destinationCurrency,
      source_amount: conversionAmount * 100,
    };
    await axios
      .post("users/swaps/convert.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setStatusMessage(result.data.data.message);
          setStatusDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("An error occurred.");
        setOpen(true);
      });
  }

  function convert() {
    if (sourceCurrency === null) {
      setSeverity("error");
      setErrMsg("Select a source currency");
      setOpen(true);
      return;
    }

    if (destinationCurrency === null) {
      setSeverity("error");
      setErrMsg("Select a destination currency");
      setOpen(true);
      return;
    }

    if (destinationCurrency === sourceCurrency) {
      setSeverity("error");
      setErrMsg("Select different currencies to convert.");
      setOpen(true);
      return;
    }

    if (
      (conversionAmount === null || conversionAmount <= 0) &&
      (targetAmount === null || targetAmount <= 0)
    ) {
      setSeverity("error");
      setErrMsg("Enter an amount in the source or target currency.");
      setOpen(true);
      return;
    }

    if (!calculated) {
      calculate();
      return;
    }

    postConversion();
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {companyNotification !== null && showCompanyNotification ? (
        <CompanyNotification
          title={companyNotification.title}
          description={companyNotification.description}
        />
      ) : (
        <> </>
      )}
      <Dialog open={openStatusDialog}>
        <DialogTitle>
          <MDBox>Conversion Submitted</MDBox>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDBox>{statusMessage}</MDBox>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            color="success"
            variant="outlined"
            onClick={() => {
              setStatusDialog(false);
              resetSwapForm();
            }}
          >
            Close
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={3} pb={3}>
        <Grid
          container
          spacing={3}
          display="flex"
          alignItems="center"
          justifyContent="space-evenly"
        >
          <Grid item xs={12} md={7} lg={7}>
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={3}>
                  <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                    Convert Funds
                  </MDTypography>
                  <MDBox mt={5}>
                    <MDBox mt={1}>
                      <FormControl sx={{ minWidth: 120, width: "100%" }}>
                        <InputLabel>From</InputLabel>
                        <Select
                          value={sourceCurrency}
                          label="From"
                          onChange={(e) => {
                            setConvertButtonText("Calculate");
                            setCalculated(false);
                            setSourceCurrency(e.target.value);
                            console.log(convertiblesList);
                            setDestinationCurrencies(convertiblesList[e.target.value]);
                          }}
                          sx={{ padding: "12px", paddingLeft: "3px" }}
                        >
                          {
                            // --> Notice below changes
                            currencies.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                              currencies.map((record) => {
                                if (record.swap_enabled) {
                                  return (
                                    <MenuItem value={record.currency_code}>
                                      {record.currency_code} Balance
                                    </MenuItem>
                                  );
                                }
                                return null;
                              })
                          }
                        </Select>
                      </FormControl>
                    </MDBox>
                    <MDBox mt={1} pl={2}>
                      <Icon color="success">south_circle</Icon>
                    </MDBox>
                    <MDBox mt={1}>
                      <FormControl sx={{ minWidth: 120, width: "100%" }}>
                        <InputLabel>To</InputLabel>
                        <Select
                          value={destinationCurrency}
                          label="To"
                          onChange={(e) => {
                            setCalculated(false);
                            setConvertButtonText("Calculate");
                            setDestinationCurrency(e.target.value);
                          }}
                          sx={{ padding: "12px", paddingLeft: "3px" }}
                        >
                          {
                            // --> Notice below changes
                            destinationCurrencies.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                              destinationCurrencies.map((record) => (
                                <MenuItem value={record}>{record} Balance</MenuItem>
                              ))
                          }
                        </Select>
                      </FormControl>
                    </MDBox>
                    <MDBox mt={4}>
                      <MDInput
                        name="source_amount"
                        margin="dense"
                        label={amountPlaceholder}
                        value={conversionAmount}
                        type="number"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => {
                          setCalculated(false);
                          setConvertButtonText("Calculate");
                          setConversionAmount(e.target.value);
                          setTargetAmount("0.00");
                        }}
                      />
                    </MDBox>
                    <MDBox mt={1} pl={2}>
                      <Icon color="success" fontSize="medium">
                        swap_vertical_circle
                      </Icon>
                    </MDBox>
                    <MDBox mt={1}>
                      <MDInput
                        name="target_amount"
                        margin="dense"
                        label={amountPlaceholder1}
                        value={targetAmount}
                        type="number"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => {
                          setCalculated(false);
                          setConvertButtonText("Calculate");
                          setTargetAmount(e.target.value);
                          setConversionAmount("0.00");
                        }}
                      />
                    </MDBox>
                    {calculated ? (
                      <MDBox mt={2}>
                        <Alert severity="info" sx={{ width: "100%" }}>
                          <MDBox>
                            <small variant="caption" fontWeight="heavy">
                              {rateLine}
                            </small>
                          </MDBox>
                          <MDBox>
                            <small variant="caption" fontWeight="medium">
                              {`Fee: ${sourceCurrency} ${transactionFee}`}
                            </small>
                          </MDBox>
                          <MDBox mt={0}>
                            <small variant="caption" fontWeight="medium">
                              <b>Rate will refresh in {timerText}</b>
                            </small>
                          </MDBox>
                        </Alert>
                      </MDBox>
                    ) : (
                      <> </>
                    )}
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={3}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={2} sx={{ textAlign: "right" }}>
                  <MDButton
                    color="success"
                    variant="contained"
                    onClick={() => {
                      convert();
                    }}
                  >
                    {convertButtonText}
                  </MDButton>
                </MDBox>
              </Card>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CreateSwap;
